import * as R from 'ramda'
import {
    FETCH_SAVED_LISTS_SUCCESS,
} from '../actionTypes'
import {snapshotToArray} from "../selectors";

const InitialState = [];

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case FETCH_SAVED_LISTS_SUCCESS:
            const arr = snapshotToArray(payload)

            return arr

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/savedLists.js